// @ts-nocheck
/// <reference path="./globals.d.ts" />

/*
[WBLS-CART] -- v1.1.02 (Optimized + Proteus-compatible + js.liquid-safe)
*/

(function () {
  'use strict';

  /* ---------------------------------------------
   * Config toggles
   * ------------------------------------------- */
  const WBLS_CART_DEBUG = false;

  // GWPs handled elsewhere now → OFF by default
  const ENABLE_GWP_CHECKOUT_HIJACK = false;

  const ENABLE_SHIPPING_BANNER = true;

  // Adds line item property on the newly added item via /cart/add.js (fast, no change.js).
  const ADD_FREE_SHIPPING_THRESHOLD_PROPERTY_ON_ADD = true;

  /* ---------------------------------------------
   * Logging / Sentry safe wrappers (scoped)
   * ------------------------------------------- */
  const cartLog = (...a) => WBLS_CART_DEBUG && console.log('[WBLS cart]', ...a);
  const cartError = (...a) => console.error('[WBLS cart]', ...a);

  const Sentry = (() => {
    const s = window.Woobles && window.Woobles.Sentry ? window.Woobles.Sentry : null;
    if (!s) {
      return {
        startSpan: (_opts, fn) => fn(),
        addInfoBreadcrumb: () => {},
        addBreadcrumb: () => {},
        addClickBreadcrumb: () => {},
        addErrorBreadcrumb: () => {},
        captureException: () => {}
      };
    }
    return s;
  })();

  /* ---------------------------------------------
   * Incentives / currency globals (Liquid-safe)
   * ------------------------------------------- */
  const progress_thresholds = "{\n        threshold_USD: 5000,\n        message: \"FREE SHIPPING\",\n        label: \"free shipping\u003cbr\u003e(U.S. only)\",\n        var_id: \"none\"\n}, {\n        threshold_USD: 10000,\n        message: \"a FREE ACCESSORY\",\n        label: `\u003cspan class=\"new-accessory-flag\"\u003eexclusive  \u003c\/span\u003emystery accessory`,\n        var_id: 45779459932326\n}";
  window.js_cart_incentives = progress_thresholds;

  // assuming free shipping is the first threshold
  const free_shipping_threshold = (progress_thresholds?.[0]?.threshold_USD) || 0;

  window.active_currency_conversion_rate = 1;
  window.active_currency = 'USD';

  if (window.location.href.indexOf('/en-ca') > -1) {
    window.active_currency = 'CAD';
    window.active_currency_conversion_rate = 1.35;
  }

  let current_cart_count = 0;
  let added_quantity = 0;

  /* ---------------------------------------------
   * DOM helpers (prefer utils versions if present)
   * ------------------------------------------- */
  const waitForElement =
    window.waitForElement ||
    function (selector) {
      return new Promise(function (resolve) {
        const el = document.querySelector(selector);
        if (el) return resolve(el);

        const observer = new MutationObserver(function (mutations) {
          for (let i = 0; i < mutations.length; i++) {
            const nodes = mutations[i].addedNodes;
            if (!nodes || !nodes.length) continue;

            for (let j = 0; j < nodes.length; j++) {
              const node = nodes[j];
              if (node && node.matches && node.matches(selector)) {
                observer.disconnect();
                return resolve(node);
              }
              if (node && node.querySelector) {
                const found = node.querySelector(selector);
                if (found) {
                  observer.disconnect();
                  return resolve(found);
                }
              }
            }
          }
        });

        observer.observe(document.documentElement, { childList: true, subtree: true });
      });
    };

  const observeSelector =
    window.observeSelector ||
    function (selector, callback) {
      const el = document.querySelector(selector);
      if (el) callback(el);
      return () => {};
    };

  /* ---------------------------------------------
   * Cart fetch helper (uses utils de-dupe if present)
   * ------------------------------------------- */
  const fetchCart = async () => {
    if (typeof window.get_cart_json === 'function') return window.get_cart_json();
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!r.ok) throw new Error('Cannot retrieve cart data');
    return r.json();
  };

  /* ---------------------------------------------
   * Local cart snapshot + Klaviyo hook (kept)
   * ------------------------------------------- */
  const maybeUpdateLocalCartData = (cart) => {
    try {
      const cart_data = {
        cart_attributes: cart.attributes,
        cart_currency: cart.currency,
        cart_item_count: cart.item_count,
        cart_line_items: cart.items,
        cart_original_price: cart.original_total_price,
        cart_subtotal: cart.items_subtotal_price,
        cart_total_discount: cart.total_discount,
        cart_total_price: cart.total_price
      };

      const next = JSON.stringify(cart_data);
      const prev = window.sessionStorage.getItem('local-cart-data');

      if (next !== prev) {
        cartLog('CHANGES TO CART - UPDATE LOCAL CART DATA');
        window.sessionStorage.setItem('local-cart-data', next);

        if (typeof window.kl_tracking_atc === 'function') {
          window.kl_tracking_atc(cart);
        }
      }
    } catch (e) {
      Sentry.captureException(e);
    }
  };

  function retrieve_cart_data_impl() {
    const expectedDelta = added_quantity;
    const expectedStart = current_cart_count;

    return Sentry.startSpan({ name: 'Retrieve Cart Data' }, async () => {
      try {
        Sentry.addInfoBreadcrumb({ message: 'Retrieving cart data' });

        const cart = await fetchCart();
        window.active_currency = cart.currency;

        Sentry.addBreadcrumb({ message: 'Cart retrieved', data: { response: cart } });

        maybeUpdateLocalCartData(cart);

        if (expectedDelta > 0) {
          if (expectedStart + expectedDelta !== cart.item_count) {
            Sentry.addErrorBreadcrumb({
              message: `${expectedDelta} items were added to cart which had ${expectedStart} in it, but only ${cart.item_count} are in the cart now`,
              data: { cart }
            });
            Sentry.captureException(new Error('Cart item count does not match expected value'));
          }
          added_quantity = 0;
        }

        current_cart_count = cart.item_count;
        return cart;
      } catch (e) {
        Sentry.captureException(e);
        cartError('Error fetching cart:', e);
        return null;
      }
    });
  }

  /* ---------------------------------------------
   * Button loading state (kept)
   * ------------------------------------------- */
  const set_atc_loading_state = (button, isLoading = false) => {
    if (!button) return;

    const text = button.querySelector('[data-add-to-cart-text]');
    const loader = button.querySelector('[data-loader]');

    button.toggleAttribute('aria-disabled', isLoading);

    if (!text || !loader) return;

    text.classList.toggle('hide', isLoading);
    loader.classList.toggle('hide', !isLoading);
  };

  /* ---------------------------------------------
   * Helpers: dataset props + threshold prop
   * ------------------------------------------- */
  const parseLineItemPropsFromDataset = (el) => {
    const props = {};
    if (!el || !el.dataset) return props;

    for (const key in el.dataset) {
      if (!Object.prototype.hasOwnProperty.call(el.dataset, key)) continue;
      if (!key.startsWith('properties')) continue;

      const raw = el.dataset[key];
      if (!raw || raw.indexOf(':') === -1) continue;

      const idx = raw.indexOf(':');
      const prop_name = raw.slice(0, idx).trim();
      const prop_value = raw.slice(idx + 1).trim();
      if (prop_name) props[prop_name] = prop_value;
    }

    return props;
  };

  const maybeAddFreeShippingThresholdProp = (props) => {
    if (!ADD_FREE_SHIPPING_THRESHOLD_PROPERTY_ON_ADD) return props;
    const thresholdDollars = free_shipping_threshold ? free_shipping_threshold / 100 : 0;
    if (!thresholdDollars) return props || {};
    return { ...(props || {}), '_free shipping threshold': thresholdDollars };
  };

  /* ---------------------------------------------
   * GLOBAL add_to_cart (Proteus-compatible)
   * ------------------------------------------- */
  window.add_to_cart = function add_to_cart(var_id, qty = 1, line_item_properties) {
    const props = maybeAddFreeShippingThresholdProp(line_item_properties);
    const body = {
      id: parseInt(var_id, 10),
      quantity: qty,
      ...(props && Object.keys(props).length ? { properties: props } : {})
    };

    return Sentry.startSpan({ name: 'Add to Cart' }, async () => {
      try {
        Sentry.addInfoBreadcrumb({ message: 'Adding item to cart', data: { payload: body } });

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        });

        if (!response.ok) {
          const detail = await response.text().catch(() => '');
          Sentry.captureException(new Error(`Cannot add item to cart (${response.status}) ${detail}`));
          return null;
        }

        added_quantity = qty;

        const data = await response.json();
        cartLog('Item added to cart:', data);

        document.dispatchEvent(new Event('cart:added'));

        Sentry.addBreadcrumb({ message: 'Item added to cart', data: { payload: body, response: data } });

        return await retrieve_cart_data_impl();
      } catch (e) {
        Sentry.captureException(e);
        cartError('Error adding item to cart:', e);
        return null;
      }
    });
  };

  // Ensure unqualified calls work: add_to_cart(...)
  // eslint-disable-next-line no-var
  var add_to_cart = window.add_to_cart;

  // Expose retrieve_cart_data too
  window.retrieve_cart_data = retrieve_cart_data_impl;
  // eslint-disable-next-line no-var
  var retrieve_cart_data = window.retrieve_cart_data;

  /* ---------------------------------------------
   * Legacy GWP checkout hijack (optional)
   * ------------------------------------------- */
  async function js_cart_build_gwp_items(cart) {
    if (!cart) cart = await fetchCart();
    const subtotal = cart.items_subtotal_price;
    let gwp_checkout_params = '';

    window.gwp_items_to_add = [];
    window.gwp_items_to_add_ref = [];

    for (let i = 0; i < (window.gwp_qualifying_items?.length || 0); i++) {
      const qualifier = window.gwp_qualifying_items[i];
      const gwp_qualifier_var_id = qualifier.var_id;
      const gwp_qualifier_threshold = qualifier.threshold ? qualifier.threshold : 999999;

      const qualifyingItem = cart.items.find((item) => item.variant_id.toString() === gwp_qualifier_var_id);
      const qualifyingItemInCart = !!qualifyingItem;

      if (qualifyingItemInCart || subtotal >= gwp_qualifier_threshold) {
        let qty_of_gwp_qualifier = 1;
        if (subtotal < gwp_qualifier_threshold && qualifyingItemInCart) {
          qty_of_gwp_qualifier = qualifyingItem?.quantity || 1;
        }
        for (let ii = 0; ii < parseInt(qty_of_gwp_qualifier, 10); ii++) {
          window.gwp_items_to_add.push(qualifier.gwp_id);
          window.gwp_items_to_add_ref.push(i);
        }
      }
    }

    for (let i = 0; i < window.gwp_items_to_add.length; i++) {
      const hidden_item_index = window.gwp_items_to_add[i];
      const gwp_var_id = window.hidden_products?.[hidden_item_index]?.var_id;
      if (!gwp_var_id) continue;

      gwp_checkout_params += `items[][id]=${gwp_var_id}&items[][quantity]=1&`;

      const q = window.gwp_qualifying_items?.[window.gwp_items_to_add_ref[i]];
      if (q?.threshold) {
        gwp_checkout_params += `items[][properties][${encodeURIComponent('_free at threshold')}]=${parseInt(
          q.threshold,
          10
        ) / 100}&`;
      }
    }

    return gwp_checkout_params;
  }

  if (ENABLE_GWP_CHECKOUT_HIJACK && window.location.href.indexOf('.com/cart') > -1) {
    observeSelector('input[type="submit"][name="checkout"]', (btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        try {
          const cart = await fetchCart();
          const gwp_checkout_params = await js_cart_build_gwp_items(cart);
          window.location.href = gwp_checkout_params
            ? `/cart/add?${gwp_checkout_params}return_to=/checkout`
            : '/checkout';
        } catch (e2) {
          cartError('Cannot retrieve cart data', e2);
          window.location.href = '/checkout';
        }
      });
    });
  }

  /* ---------------------------------------------
   * ATC click handling (event delegation)
   * ------------------------------------------- */
  const ATC_CLICK_SELECTOR =
    '[data-add-to-cart], button[data-add-to-cart], a[data-add-to-cart], [class*="add-to-cart"]';

  document.addEventListener(
    'click',
    (e) => {
      const target = e.target;
      if (!target) return;

      const btn = target.closest ? target.closest(ATC_CLICK_SELECTOR) : null;
      if (!btn) return;

      if (btn.getAttribute('aria-disabled') === 'true' || btn.hasAttribute('disabled')) return;

      const var_id = btn.getAttribute('data-add-to-cart');

      set_atc_loading_state(btn, true);

      Sentry.addClickBreadcrumb({
        message: 'Clicked Add to Cart',
        data: { html: btn.outerHTML }
      });

      if (var_id) {
        const props = parseLineItemPropsFromDataset(btn);
        window.add_to_cart(var_id, 1, props).finally(() => set_atc_loading_state(btn, false));
        return;
      }

      window.retrieve_cart_data().finally(() => set_atc_loading_state(btn, false));
    },
    true
  );

  /* ---------------------------------------------
   * Banner injection (guarded)
   * ------------------------------------------- */
  if (ENABLE_SHIPPING_BANNER) {
    waitForElement('body')
      .then((doc) => {
        if (doc.querySelector('#js-shipping-banner')) return;

        doc.insertAdjacentHTML(
          'afterbegin',
          `
          <div
            id="js-shipping-banner"
            class="js-shipping-banner"
            style="
              background: #1F1B68;
              padding: .5rem 1rem;
              color: white;
              font-weight: 600;
              text-align: center;
              position: sticky;
              top: 0;
              z-index: 9999;
              cursor: pointer;
            "
          >
            FREE shipping on $50+ 🚚
          </div>
        `
        );
      })
      .catch((e) => {
        Sentry.captureException(e);
      });
  }
})();